/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { Heading } from '@msdyn365-commerce-modules/utilities';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import classname from 'classnames';
import * as React from 'react';
import { IContentBlockWithTitleData } from './content-block-with-title.data';
import {
    IContentBlockWithTitleConfig,
    IContentBlockWithTitleProps,
    ITitleData
} from './content-block-with-title.props.autogenerated';

// ==============================================================================
/**
 * ContentBlockWithTitle component
 * @extends {React.PureComponent<IContentBlockWithTitleProps<IContentBlockWithTitleData>>}
 */
// ==============================================================================
class ContentBlockWithTitle extends React.PureComponent<IContentBlockWithTitleProps<IContentBlockWithTitleData>> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { config, slots } = this.props;

        return (
            <div className={classname('content-block-with-title', config.className)}>
                {config && config.title && this._renderLinkedTitle(config)}
                {config && config.text &&
                    // tslint:disable-next-line:react-no-dangerous-html
                    <div
                        className='content-block-with-title-text'
                        dangerouslySetInnerHTML={getRichTextHtml(config.text)}
                    />
                }
                {slots.contentBlockNoHeadings && this._renderSlotItems(slots.contentBlockNoHeadings)}
            </div>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderLinkedTitle(config: IContentBlockWithTitleConfig): JSX.Element {
        if (config.link && config.link.linkUrl.destinationUrl) {
            return (
                <a href={config.link.linkUrl.destinationUrl} aria-label={config.link.ariaLabel}>
                    {this._renderTitle(config.title!)}
                </a>
            );
        } else {
            return this._renderTitle(config.title!);
        }
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderTitle(title: ITitleData): JSX.Element {
        if (title.text === '') {
            return <></>;
        }
        else {
            return (
                <Heading
                    className='content-block-with-title-title'
                    headingTag={title.tag}
                    text={title.text}
                />
            );
        }
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderSlotItems(items: React.ReactNode[]): JSX.Element {
        return (
            <div className='container-with-header-slots'>
                {items.map((slot: React.ReactNode, index: number) => (
                    <React.Fragment key={index}>
                        {slot}
                    </React.Fragment>
                ))}
            </div>
        );
    }
}

export default ContentBlockWithTitle;